import { render, staticRenderFns } from "./pvList.vue?vue&type=template&id=0779e546&scoped=true"
import script from "./pvList.vue?vue&type=script&lang=js"
export * from "./pvList.vue?vue&type=script&lang=js"
import style0 from "./pvList.vue?vue&type=style&index=0&id=0779e546&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0779e546",
  null
  
)

export default component.exports